import cloneDeep from 'lodash/cloneDeep';
import {
  ADD_SIGNALS,
  CLEAN_SIGNALS,
  createSignalPayload,
  signalsActionTypes,
  TOGGLE_SIGNALS,
} from './types';

const initialState: createSignalPayload = {};

export const componentSignalsReducer = function (
  state = initialState,
  action: signalsActionTypes,
) {
  let newState: createSignalPayload;
  switch (action.type) {
    case ADD_SIGNALS:
      newState = cloneDeep(state);

      for (const id in action.signalsValuesPool) {
        const signals = action.signalsValuesPool[id];
        if (!newState[id]) {
          newState[id] = signals;
          continue;
        } else {
          Object.assign(newState[id], signals);
        }
      }
      return newState;

    case TOGGLE_SIGNALS:
      newState = cloneDeep(state);
      for (const id in action.signalsToToggle) {
        for (const key of action.signalsToToggle[id]) {
          newState[id][key] = !newState[id][key];
        }
      }
      return newState;

    case CLEAN_SIGNALS:
      newState = cloneDeep(state);
      for (const id in action.signalsToDrop) {
        for (const key of action.signalsToDrop[id]) {
          delete newState[id][key];
        }
      }
      return newState;
    default:
      return state;
  }
};
